import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import { QuickStartView } from "./quickstart-view";

export const QuickStart = (props) => {
	const [results, setResults] = useState([]);
	const [tourComplete, setTourComplete] = useState("");
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	
	useEffect(() => {
		const search = async () => {
			const apiUrl = `/home?param=homedata&uid=${usid}`;
			const { data } = await serviceProvider.get(apiUrl,true,{});
			setResults(data);
		};
		search();
	}, [tourComplete]);

	if (results.length) {
			return (
				<>
					<QuickStartView homeData={results} onTourComplete={setTourComplete} {...props} />
				</>
			);
	}else{
		return (
					<>
						<div></div>
					</>
			);
		
		}
};
